<template>
  <qx-card :noTitle="true">
    <BankcardDialog ref="bankcardDialog" />
    <RechargeDialog ref="rechargeDialog" />
    <qx-detail-box
      v-for="item in accountDataList"
      :data="item"
      :key="item.key"
    >
      <!-- 余额 -->
      <section class="clearPa" slot="businessAccount" slot-scope="prop">
        <article class="left error">{{prop.data.businessAccount / 100}}</article>
        <article class="right">
          <span class="primary btn cur" @click="showRechargeDialog(prop.data)">充值</span>
          <span class="primary btn cur" @click="toWithdraw(item)">提现</span>
          <span class="primary btn cur" @click="toChangeMoney(item)">资金互转</span>
        </article>
      </section>
      <!-- 余额 end -->
      <!-- 收款公户 -->
      <section slot="businessReceivableAccount" class="error" slot-scope="prop">
        {{prop.data.businessReceivableAccount / 100}}
      </section>
      <!-- 收款公户 end -->
      <!-- 付款公户 -->
      <section slot="businessPayableAccount" class="error" slot-scope="prop">
        {{prop.data.businessPayableAccount / 100}}
      </section>
      <!-- 付款公户 end -->
      <!-- 余额 -->
      <section class="clearPa" slot="privateAccount" slot-scope="prop">
        <article class="left error">{{prop.data.privateAccount / 100}}</article>
        <article class="right">
          <span class="primary btn cur" @click="showRechargeDialog(prop.data)">充值</span>
          <span class="primary btn cur" @click="toWithdraw(item)">提现</span>
          <span class="primary btn cur" @click="toChangeMoney(item)">资金互转</span>
        </article>
      </section>
      <!-- 余额 end -->
      <!-- 收款私户 -->
      <section slot="privateReceivableAccount" class="error" slot-scope="prop">
        {{prop.data.privateReceivableAccount / 100}}
      </section>
      <!-- 收款私户 end -->
      <!-- 付款私户 -->
      <section slot="privatePayableAccount" class="error" slot-scope="prop">
        {{prop.data.privatePayableAccount / 100}}
      </section>
      <!-- 付款私户 end -->
      <!-- 应收逾期 -->
      <section slot="receivableOverdueBalance" class="error" slot-scope="prop">
        <span class="cur" @click="toExpireGet">{{prop.data.receivableOverdueBalance / 100}}</span>
      </section>
      <!-- 应收逾期 end -->
      <!-- 应付逾期 -->
      <section slot="payableOverdueBalance" class="error" slot-scope="prop">
        <span class="cur" @click="toExpirePay">{{prop.data.payableOverdueBalance / 100}}</span>
        <qx-tips
            content="应付逾期一方面可能由于未设置自动打款或者平安账户余额不足时产生，另一方面可能由于承运的订单发生了撤单、异常款、ETC消费以及招商车扣费等异常产生。"
          />
      </section>
      <!-- 应付逾期 end -->
    </qx-detail-box>
    <p class="textCenter"><el-button type="primary" @click="toRecord">流水查询</el-button></p>
  </qx-card>
</template>

<script>
import {
  myAccount,
} from 'api/user';
import BankcardDialog from './bankcardDialog';
import RechargeDialog from './rechargeDialog';
import {
  mapState,
} from 'vuex';
export default {
  components: {
    BankcardDialog,
    RechargeDialog,
  },
  data () {
    return {
      totalAmount: 0,
      accountDataList: {
        public: {
          key: 'public',
          label: '对公账户(元)',
          tableData: {
            title: [
              {
                prop: 'businessAccount',
                label: '余额(元)',
                width: '100%',
                slot: true,
              },
              {
                prop: 'businessReceivableAccount',
                label: '收款公户(元)',
                slot: true,
                width: '50%',
              },
              {
                prop: 'businessPayableAccount',
                label: '付款公户(元)',
                slot: true,
                width: '50%',
              },
            ],
            data: {

            },
            approveData: {},
          },
        },
        private: {
          key: 'private',
          label: '对私账户(元)',
          tableData: {
            title: [
              {
                prop: 'privateAccount',
                label: '余额(元)',
                width: '100%',
                slot: true,
              },
              {
                prop: 'privateReceivableAccount',
                label: '收款私户(元)',
                slot: true,
                width: '50%',
              },
              {
                prop: 'privatePayableAccount',
                label: '付款私户(元)',
                slot: true,
                width: '50%',
              },
            ],
            data: {

            },
            approveData: {},
          },
        },
        expire: {
          key: 'expire',
          label: '逾期(元)',
          tableData: {
            title: [
              {
                prop: 'receivableOverdueBalance',
                label: '应收逾期(元)',
                width: '50%',
                slot: true,
              },
              {
                prop: 'payableOverdueBalance',
                label: '应付逾期(元)',
                slot: true,
                width: '50%',
              },
            ],
            data: {

            },
            approveData: {},
          },
        },
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  methods: {
    showRechargeDialog (item) { // 充值
      this.$refs.rechargeDialog.show(item);
    },
    showBankcardDialog (item) { // 明细
      this.$refs.bankcardDialog.show(item);
    },
    toWithdraw (item) { // 提现
      this.jump({
        label: (item.key === 'public' ? '对公' : '对私') + '账户提现',
        url: '/manage/other/myAccount/withdraw?type=' + item.key,
        full: true,
      });
    },
    toChangeMoney (item) { // 资金互转
      this.jump({
        label: (item.key === 'public' ? '对公' : '对私') + '账户资金互转',
        url: '/manage/other/myAccount/changeMoney?type=' + item.key,
        full: true,
      });
    },
    toRecord () {
      this.jump({
        label: '流水查询',
        url: '/manage/other/myAccount/record',
      });
    },
    toExpireGet () {
      this.jump({
        label: '应收逾期',
        url: '/manage/other/myAccount/expireGet',
      });
    },
    toExpirePay () {
      this.jump({
        label: '应付逾期',
        url: '/manage/other/myAccount/expirePay',
      });
    },
  },
  async created () {
    const accountRes = await myAccount({
      userId: this.userInfo.staffTFInfo.userId,
      userType: 1,
    });
    this.accountDataList.public.tableData.data = accountRes;
    this.accountDataList.private.tableData.data = accountRes;
    this.accountDataList.expire.tableData.data = accountRes;
  },
};
</script>

<style scoped lang="scss">
.title{
  height: 32px;
  padding-top: 8px;
  padding-bottom: 28px;
  border-bottom: 1px solid #e0e0e0;
  .totalAmount{
    font-size: 32px;
  }
}
.btn{
  margin-left: 16px;
}
</style>
